import { createFeatureSelector, createSelector } from '@ngrx/store';
import type { CoreState } from '../core.state';

const featureSelector = createFeatureSelector<CoreState>('core');

export const selectMeasurementUnitsState = createSelector(featureSelector, state => state.measurementUnits);

export const selectMeasurementUnits = createSelector(selectMeasurementUnitsState, state => state.measurementUnits);

export const selectMeasurementUnit = (unitKey: string) => createSelector(selectMeasurementUnits, units => units[unitKey]);
